export const FirebaseConfig = {
    
        apiKey: "AIzaSyAIv79np1tlevuUq1UViEHrVlbmsQCCBFw",
        authDomain: "courtspace-v2.firebaseapp.com",
        databaseURL: "https://courtspace-v2.firebaseio.com",
        projectId: "courtspace-v2",
        storageBucket: "courtspace-v2.appspot.com",
        messagingSenderId: "1069396590311"   
}

export const settings = {timestampsInSnapshots:true}




